import { render, staticRenderFns } from "./alexion.vue?vue&type=template&id=1000f45b&"
import script from "./alexion.vue?vue&type=script&lang=js&"
export * from "./alexion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports